import { createContext, useContext, useCallback, useMemo } from "react";
import LanguageHelper from "../../helpers/LanguageHelper";
import { languageStorage } from "../../helpers/StorageHelper";
import ILanguage from "../../interfaces/ILanguage";
import { LanguageTypes } from "../../data/Languages";
import useState from "../../hooks/useState";


interface ILanguageContext {
    language: ILanguage;
    handleChangeLanguage: (languageValue: string) => void;
    translate: (text: string, languageValue?: string) => string;
}

interface IStateValues {
    language: ILanguage;
}


const LanguageContext = createContext<ILanguageContext | undefined>(undefined);

const LanguageContextProvider = (props: React.PropsWithChildren) => {
    const state = useState<IStateValues>({
        language: languageStorage.get()
    });

    
    const _handleChangeLanguage = useCallback((languageValue: string) => {
        const language = languageStorage.validate(languageValue);
        
        languageStorage.set(language);
        state.update('language', language);
        // eslint-disable-next-line
    }, []);


    const handleTranslation = useCallback((text: string, languageValue?: string) => {
        languageValue = languageStorage.validate(languageValue ?? state.values.language.value).value;
        return LanguageHelper.FindTranslation(text)[languageValue as LanguageTypes];
        // eslint-disable-next-line
    }, [state.values.language]);


    const data: ILanguageContext = useMemo(() => {
        return {
            language: state.values.language,
            handleChangeLanguage: _handleChangeLanguage,
            translate: handleTranslation
        };
        
        // eslint-disable-next-line
    }, [state.values]);

    return (
        <LanguageContext.Provider value={data}>
            {props.children}
        </LanguageContext.Provider>
    );
}


const useLanguageContext = () => {
    const context = useContext(LanguageContext);
    
    if (context === undefined) {
        throw new Error('useLanguageContext must be used within a LanguageContextProvider');
    }
    
    return context;
}


export {
    useLanguageContext
}

export default LanguageContextProvider;